import { Attachment } from "./chat"
import { CollectionRef } from "./collection"
import { Timestamp } from "./date"
import { EntityRef, InspirationRef, PlaceRef, ShareableUrl } from "./entity"
import {
  LocationSummary,
  PlaceAudio,
  PlacePhoto,
  PlacePlaceholder,
  PlaceSummary,
} from "./place"
import { PublicUser } from "./user"

export const InspirationInitialBlankType = "initial-blank"
export const InspirationInitialItineraryType = "initial-itinerary"
export const InspirationInitialListType = "initial-list"

export const InspirationAllStatus = "all"
export const InspirationPublishedStatus = "published"
export const InspirationUnPublishedStatus = "unpublished"

export const InspirationFeatured = "featured"
export const InspirationNormal = "normal"
export const InspirationBuried = "buried"
export const InspirationUnlisted = "unlisted"

export const InspirationPaymentAll = "all"
export const InspirationPaymentRequired = "required"
export const InspirationPaymentFree = "free"

export type InspirationPublishMode = "public" | "org_only" | "private"

export const InspirationEditedMode = "edited"
export const InspirationPublishedMode = "published"

export const InspirationTitleWhere = "title"
export const InspirationDaySectionTitleWhere = "day-section-title"
export const InspirationDaySectionContentWhere = "day-section-content"
export const InspirationContentWhere = "content"
export const InspirationTipsWhere = "tips"
export const InspirationAddressWhere = "address"
export const InspirationPhoneWhere = "phone"
export const InspirationQuoteTextWhere = "quote-text"
export const InspirationQuoteAuthorWhere = "quote-author"
export const InspirationLayoutWhere = "layout"
export const InspirationImageWhere = "image"
export const InspirationImageDisplayModeWhere = "image-display-mode"
export const InspirationOwnerWhere = "owner"
export const InspirationLocationWhere = "location"
export const InspirationRemoveLocationWhere = "remove-location"
export const InpsirationEventTimeWhere = "event-time"
export const InspirationItemAddBlock = "item-add-block"
export const InspirationItemAddBlockBefore = "item-add-block-before"
export const InspirationItemAddBlockAfter = "item-add-block-after"
export const InspirationItemUpdateBlock = "item-update-block"
export const InspirationItemAddAudioInBlock = "item-add-audio-in-block"
export const InspirationItemAddLinkInBlock = "item-add-link-in-block"
export const InspirationItemDeleteAudioInBlock = "item-delete-audio-in-block"
export const InspirationItemDeleteLinkInBlock = "item-delete-link-in-block"
export const InspirationItemDelete = "item-delete"
export const InspirationImageSourceWhere = "image-source"
export const InspirationImageSourceAllWhere = "image-source-all"
export const InspirationImageAddToCover = "image-add-to-cover"
export const InspirationItemMoveEarlier = "item-move-earlier"
export const InspirationItemMoveLater = "item-move-later"
export const InspirationItemMoveTo = "item-move-to"
export const InspirationItemMoveBefore = "item-move-before"
export const InspirationItemMoveAfter = "item-move-after"
export const InspirationItemSplit = "item-split"
export const InspirationItemMergePrevious = "item-merge-previous"
export const InspirationItemDuplicate = "item-duplicate"
export const InspirationItemRestore = "item-restore"
export const InspirationItemGenerateDescription = "item-generate-description"
export const InspirationItemChangeSize = "item-change-size"
export const InspirationItemShowTitle = "item-show-title"
export const InspirationItemShowTime = "item-show-time"
export const InspirationShowAllTime = "show-all-time"

export const InspirationFlexibleTemplate = "flexible-template"

export const InspirationPhotoSlideShowDisplay = "slide-show"
export const InspirationPhotoSingleImageDisplay = "single"

export const DefaultInspirationPerPage = 15
export const INSPIRATION_RECENT_SEARCHES_STORAGE_KEY =
  "inspirationRecentSearches"
export const INSPIRATION_RECENT_SEARCHES_MAX = 5
export const InspirationTitleMaxLength = 64

export const InspirationItemBlockDaySection = "day-section"
export const InspirationItemBlockHeaderLarge = "header-large"
export const InspirationItemBlockHeaderMedium = "header-medium"
export const InspirationItemBlockHeaderNormal = "header-normal"
export const InspirationItemBlockBodyText = "body-text"
export const InspirationItemBlockQuote = "quote"
export const InspirationItemBlockDivider = "divider"
export const InspirationItemBlockLink = "link"
export const InspirationItemBlockImageVideo = "image-video"
export const InspirationItemBlockPlace = "place"
export const InspirationItemBlockActivity = "activity"
export const InspirationItemBlockAudio = "audio"
export const InspirationItemBlockGuide = "guide"

export const InspirationSectionIdPrefix = "section_"
export const InspirationDayIdPrefix = "day_"

export const InspirationLayoutMapRight = "map-right"
export const InspirationLayoutMapBottom = "map-bottom"

export const InspirationContentSourceSystem = "default-system"
export const InspirationContentSourceAI = "ai-generated"
export const InspirationContentSourceUser = "user-entered"

export type InspirationStatus =
  | typeof InspirationAllStatus
  | typeof InspirationPublishedStatus
  | typeof InspirationUnPublishedStatus

export type InspirationVisibility =
  | typeof InspirationFeatured
  | typeof InspirationNormal
  | typeof InspirationBuried
  | typeof InspirationUnlisted

export type InspirationPayment =
  | typeof InspirationPaymentRequired
  | typeof InspirationPaymentFree
  | typeof InspirationPaymentAll

export type InspirationEditingMode =
  | typeof InspirationEditedMode
  | typeof InspirationPublishedMode

export type InspirationWhere =
  | typeof InspirationTitleWhere
  | typeof InspirationDaySectionTitleWhere
  | typeof InspirationDaySectionContentWhere
  | typeof InspirationContentWhere
  | typeof InspirationTipsWhere
  | typeof InspirationAddressWhere
  | typeof InspirationPhoneWhere
  | typeof InspirationQuoteTextWhere
  | typeof InspirationQuoteAuthorWhere
  | typeof InspirationLayoutWhere
  | typeof InspirationImageWhere
  | typeof InspirationImageDisplayModeWhere
  | typeof InspirationOwnerWhere
  | typeof InspirationLocationWhere
  | typeof InspirationRemoveLocationWhere
  | typeof InpsirationEventTimeWhere
  | typeof InspirationItemAddBlock
  | typeof InspirationItemAddBlockBefore
  | typeof InspirationItemAddBlockAfter
  | typeof InspirationItemUpdateBlock
  | typeof InspirationItemAddAudioInBlock
  | typeof InspirationItemAddLinkInBlock
  | typeof InspirationItemDeleteAudioInBlock
  | typeof InspirationItemDeleteLinkInBlock
  | typeof InspirationItemDelete
  | typeof InspirationImageSourceWhere
  | typeof InspirationImageSourceAllWhere
  | typeof InspirationImageAddToCover
  | typeof InspirationItemMoveEarlier
  | typeof InspirationItemMoveLater
  | typeof InspirationItemMoveTo
  | typeof InspirationItemMoveBefore
  | typeof InspirationItemMoveAfter
  | typeof InspirationItemSplit
  | typeof InspirationItemMergePrevious
  | typeof InspirationItemDuplicate
  | typeof InspirationItemRestore
  | typeof InspirationItemGenerateDescription
  | typeof InspirationItemChangeSize
  | typeof InspirationItemShowTitle
  | typeof InspirationItemShowTime
  | typeof InspirationShowAllTime

export type InspirationTemplate = typeof InspirationFlexibleTemplate

export type InspirationPhotoDisplay =
  | typeof InspirationPhotoSlideShowDisplay
  | typeof InspirationPhotoSingleImageDisplay

export type InspirationBlock =
  | typeof InspirationItemBlockDaySection
  | typeof InspirationItemBlockHeaderLarge
  | typeof InspirationItemBlockHeaderMedium
  | typeof InspirationItemBlockHeaderNormal
  | typeof InspirationItemBlockBodyText
  | typeof InspirationItemBlockQuote
  | typeof InspirationItemBlockDivider
  | typeof InspirationItemBlockLink
  | typeof InspirationItemBlockPlace
  | typeof InspirationItemBlockActivity
  | typeof InspirationItemBlockImageVideo
  | typeof InspirationItemBlockGuide

export type InspirationLayout =
  | typeof InspirationLayoutMapRight
  | typeof InspirationLayoutMapBottom

export type InspirationInitialState =
  | typeof InspirationInitialBlankType
  | typeof InspirationInitialListType
  | typeof InspirationInitialItineraryType

export type InspirationContentSource =
  | typeof InspirationContentSourceSystem
  | typeof InspirationContentSourceAI
  | typeof InspirationContentSourceUser

export const InspirationPayments: InspirationPayment[] = [
  InspirationPaymentAll,
  InspirationPaymentFree,
  InspirationPaymentRequired,
] as const

export const InspirationStatuses = [
  InspirationAllStatus,
  InspirationPublishedStatus,
  InspirationUnPublishedStatus,
]

export const InspirationLayouts = [
  InspirationLayoutMapRight,
  InspirationLayoutMapBottom,
]

export const InspirationInitialStates: InspirationInitialState[] = [
  InspirationInitialBlankType,
  InspirationInitialListType,
  InspirationInitialItineraryType,
]

export const InspirationLayoutNameList = [
  { label: "Split screen", value: InspirationLayoutMapRight },
  { label: "Full screen", value: InspirationLayoutMapBottom },
]

export const InspirationInitialStateList: {
  label: string
  value: InspirationInitialState
}[] = [
  { label: "Blank", value: InspirationInitialBlankType },
  { label: "List", value: InspirationInitialListType },
  { label: "Itinerary", value: InspirationInitialItineraryType },
]

export const InspirationImageDisplayModeList = [
  { label: "Single image", value: InspirationPhotoSingleImageDisplay },
  { label: "Slideshow", value: InspirationPhotoSlideShowDisplay },
]

export const InspirationItemBlockNameList: {
  label: string
  value: InspirationBlock
}[] = [
  { label: "Place", value: InspirationItemBlockPlace },
  { label: "Activity", value: InspirationItemBlockActivity },
  { label: "Body text", value: InspirationItemBlockBodyText },
  { label: "Large heading", value: InspirationItemBlockHeaderLarge },
  { label: "Medium heading", value: InspirationItemBlockHeaderMedium },
  { label: "Normal heading", value: InspirationItemBlockHeaderNormal },
  { label: "Divider", value: InspirationItemBlockDivider },
  { label: "Link", value: InspirationItemBlockLink },
  { label: "Image/Video", value: InspirationItemBlockImageVideo },
  { label: "Guide", value: InspirationItemBlockGuide },
  { label: "Day", value: InspirationItemBlockDaySection },
  { label: "Quote", value: InspirationItemBlockQuote },
]

export const InspirationDefaultTitleText = "Add a title"
export const InspirationDefaultQuoteText = "Enter new quote"
export const InspirationDefaultQuoteAuthorText = "Author"
export const InspirationDefaultSummaryText = "Enter new summary paragraph"
export const InspirationDefaultDaySummaryText = "Enter a summary paragraph"
export const InspirationDefaultDescriptionText = "Add description…"
export const InspirationDefaultHotelTipsText =
  "- Book a corner suite for the best ocean views.\n- Check out the rooftop bar for cocktails and music.\n- Join their loyalty program for free breakfast."
export const InspirationDefaultRestaurantTipsText =
  "- Don’t miss the truffle pasta—it’s their best dish.\n- Ask for patio seating; the view is great.\n- Go for lunch—same portions, better prices."
export const InspirationDefaultAttractionTipsText =
  "- Visit early to avoid crowds and get great photos.\n- Find the garden behind the exhibit—it’s stunning.\n- Wear comfy shoes; the walk to the top is steep!"
export const InspirationDefaultPlaceText = "Place title"
export const InspirationDefaultActivityText = "Activity title"
export const InspirationDefaultSectionText = "Add a section title"

export const InspirationDefaultBlockHeaderText = "Enter heading text"
export const InspirationDefaultBlockBodyText = "Enter text"

export const InspirationDefaultDaySectionTitle = "Day title"
export const InspirationDefaultDaySectionContent = "Enter summary of the day"

export interface DayDetails {
  [key: string]: {
    title: string
    content: string
    quote?: string
    quote_show: boolean
    author?: string
  }
}

export interface InspirationStop {
  location: LocationSummary
  days?: number
}

export interface AbstractInspiration {
  detailed: boolean
  entity_ref: InspirationRef
  type: "list" | "itinerary"
  title: string
  canonical_url: string
  canonical_name: string
  shareable_urls: ShareableUrl[]
  content: string
  status: InspirationStatus
  visibility: InspirationVisibility
  payment: InspirationPayment
  total_days: number
  total_places: number
  photos: PlacePhoto[]
  photo_display_mode: InspirationPhotoDisplay
  owner: PublicUser
  location?: LocationSummary
  inspiration_stops?: InspirationStop[]
  template: InspirationTemplate
  layout: InspirationLayout
  time_zone: string
  last_edited_at: Timestamp
  is_from_thatch: boolean
  fetch_count?: number
  total_count?: number
  sections_count?: number
  search_debug?: object
  can_duplicate?: boolean
  customer_name?: string
  derived_from_ref?: InspirationRef
  can_customize?: boolean
  can_convert_to_guide?: boolean
  can_delete?: boolean
}

export interface InspirationSummary extends AbstractInspiration {
  detailed: false
}

export interface InspirationSuggestLocation {
  geo_id: number
  name: string
  context?: string
  photo?: PlacePhoto
}

export interface InspirationSuggestions {
  guides: InspirationSummary[]
  locations: InspirationSuggestLocation[]
  creators: PublicUser[]
}

export interface CustomMapPlace {
  inspiration_item_id: number
  name: string
  address?: string
  latitude: number
  longitude: number
}

export interface DetailedInspiration extends AbstractInspiration {
  detailed: true
  items: InspirationItem[]
  day_details: DayDetails
  destination_items?: DetailedInspirationItem[]
  map_places: PlacePlaceholder[]
  custom_map_places: CustomMapPlace[]
  owning_organization?: {
    orgid: string
    name: string
    default_publish_mode: InspirationPublishMode
  }
  live_copy_count?: number
}

export type Inspiration = DetailedInspiration | InspirationSummary

export interface AbstractInspirationItem {
  detailed: boolean
  id: number
  title: string
  content: string
  block_type: InspirationBlock
  time_zone: string
  sort: number
  photos: PlacePhoto[]
  photo_display_mode: InspirationPhotoDisplay
  attachments?: Attachment[]
  referred_inspiration?: Inspiration
  place_entity_ref?: PlaceRef
  show_time?: boolean
  event_time?: Timestamp
  sort_order: number
  address?: string
  phone_number?: string
  latitude?: number
  longitude?: number
}

export interface InspirationItemSummary extends AbstractInspirationItem {
  detailed: false
}

export interface DetailedInspirationItem extends AbstractInspirationItem {
  detailed: true
  tips: string
  place: PlaceSummary | undefined
  show_title?: boolean
  audio?: PlaceAudio
}

export type InspirationItem = InspirationItemSummary | DetailedInspirationItem

export interface InitGuideProps {
  guide: DetailedInspiration
}

export interface InitInspirationProps {
  error?: string
}

export interface FavoriteInspiration {
  updated_at: Timestamp
  entity_ref: EntityRef
  collections?: CollectionRef[]
}

export interface InspirationVersionSummary {
  id: number
  kind: "edit" | "restore"
  edited_at: Timestamp
  edited_by?: PublicUser
  edited_by_mindtrip?: boolean
  title?: string
  items_count: number
  changes?: InspirationVersionChanges
}

export interface InspirationVersionChanges {
  added_places: string[]
  added_count: number
  removed_places: string[]
  removed_count: number
  edited_count: number
  reordered: boolean
  renamed: boolean
  details_edited: boolean
}

export interface InspirationVersionsResponse {
  current: {
    edited_at: Timestamp
    edited_by?: PublicUser
    edited_by_mindtrip?: boolean
    changes?: InspirationVersionChanges
  }
  versions: InspirationVersionSummary[]
}
